/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getCluster } from '@/reducers/clusters'

import { getConfigForKey } from '../../selectors'
import { withStackDeploymentRouteParams } from '../StackDeploymentEditor'

import DeploymentLockGate from './DeploymentLockGate'

import type { ReduxState } from '@/types/redux'
import type { WithStackDeploymentRouteParamsProps } from '../StackDeploymentEditor'
import type { ReactNode } from 'react'

type StateProps = {
  isLocked: boolean
}

interface DispatchProps {}

type ConsumerProps = {
  children?: ReactNode
  onLocked?: () => ReactNode
}

type ConnectedProps = ConsumerProps & WithStackDeploymentRouteParamsProps

const mapStateToProps = (
  state: ReduxState,
  { regionId, deploymentId }: ConnectedProps,
): StateProps => {
  const uc = getConfigForKey(state, `APP_NAME`) === `userconsole`
  const cluster = deploymentId ? getCluster(state, regionId, deploymentId) : null

  /* [1]: if we can't get a `cluster`, we're likely to render spinners.
   *
   * even if a cluster is actually locked, it is only in
   * the userconsole that we honor that predicament.
   *
   */
  const isLocked = Boolean(
    cluster && // [1]
      cluster.isLocked &&
      uc, // [2]
  )

  return {
    isLocked,
  }
}

const mapDispatchToProps: DispatchProps = {}

export default withStackDeploymentRouteParams(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(DeploymentLockGate),
)
